import { useVKConnectStore } from '@academica-box/composables/store/VKConnect'
import { VKConnect } from '@/plugins/VKConnect/VKConnect'
import type { IVKConnect, VKConnectAuthData, VKConnectUserData } from '@/plugins/VKConnect/types'

declare module '#app' {
  interface NuxtApp {
    $VKConnect: IVKConnect;
  }
}

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig()
  const VKConnectStore = useVKConnectStore()
  const { $api, $sentry } = useNuxtApp()

  const VKConnectInstance = new VKConnect({
    appId: Number(config.public.VKAppId),
    logger: (error: any) => {
      $sentry.captureException(error)
    },
    tokenChangeFunction: (authData: VKConnectAuthData) => {
      return new Promise((resolve, reject) => {
        $api.vkConnect.getVkConnectUser(authData.token, authData.uuid)
          .then((userData) => {
            resolve(userData)
          })
          .catch((error: any) => {
            reject(error)
          })
      })
    },
    onUseDataChange: (userData: VKConnectUserData) => {
      VKConnectStore.setUserData(userData)
    }
  })

  if (process.env.NODE_ENV !== 'development') {
    VKConnectInstance.init()
  }

  return {
    provide: {
      VKConnect: VKConnectInstance
    },
  }
})
